import React from 'react';
import { VIDEO, COLORS } from '../../data/siteData';

// Video provided by user
const VIDEO_URL = "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/vuylxe7e_Bibliomats.Lv%20-%20Eng%20-%20Compressed.mp4";

const VideoSection = () => {
  return (
    <section className="py-20" style={{ backgroundColor: COLORS.background }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: COLORS.dark }}>
            {VIDEO.title}
          </h2>
          <p className="text-lg" style={{ color: COLORS.gray }}>
            {VIDEO.subtitle}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl bg-gray-900">
            <video 
              controls
              className="w-full h-full object-cover"
              poster=""
              preload="metadata"
            >
              <source src={VIDEO_URL} type="video/mp4" />
              Jūsų naršyklė nepalaiko vaizdo įrašų atkūrimo.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
